"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEstateChartsState = exports.defaultEstateChartState2 = exports.defaultEstateChartState1 = void 0;
exports.defaultEstateChartState1 = {
    title: '3 Years',
    active: true,
    xLabels: ['Jan\n2016', 'Jan\n2017', 'Jan\n2018'],
    yLabels: ['<5M', '5-10m', '10m+'],
    yValues: [
        [10, 20, 30],
        [4, 5, 6],
        [6, 10, 2],
    ],
    priceRanges: [
        { from: 0, to: 5000000 },
        { from: 5000000, to: 10000000 },
        { from: 10000000, to: -1 },
    ],
    xTitle: 'Month',
    yTitle: 'No. of Transactions',
};
exports.defaultEstateChartState2 = {
    title: '5 Years',
    active: false,
    xLabels: ['Jan\n2016', 'Jan\n2017', 'Jan\n2018', 'Jan\n2019', 'Jan\n2020'],
    yLabels: ['<5M', '5-10m', '10m+'],
    yValues: [
        [10, 20, 30, 20, 10],
        [4, 5, 6, 8, 4],
        [6, 10, 2, 4, 9],
    ],
    priceRanges: [
        { from: 0, to: 5000000 },
        { from: 5000000, to: 10000000 },
        { from: 10000000, to: -1 },
    ],
    xTitle: 'Month',
    yTitle: 'No. of Transactions',
};
exports.defaultEstateChartsState = [
    exports.defaultEstateChartState1, exports.defaultEstateChartState2,
];
